import logo from '../assets/images/logo.svg';

const Logo = () => {
  return <img src={logo} alt='jobster logo' className='logo' />;
};
export default Logo;
